import { ApiRequest } from "src/models/api.request";
import HbsVeznePoscihaztanimDTO from "src/models/Vezne/PosCihazTanim/HbsVeznePoscihaztanimDTO";
import { ApiService } from "src/services/core";
import { helper } from "src/utils/helper";

class HbsVeznePoscihaztanimDTOService {
    private service: ApiService<HbsVeznePoscihaztanimDTO>;
    constructor() {
        this.service = new ApiService<HbsVeznePoscihaztanimDTO>("HbsVeznePoscihaztanimDTO");
    };
    createUpdate = (data: HbsVeznePoscihaztanimDTO) => {
        if (data.id > 0) {
            return this.service.update({
                ...data,
                adi: helper.UpperCaseAsc(data.adi)
            });
        } else {
            return this.service.create({
                ...data,
                adi: helper.UpperCaseAsc(data.adi)
            });
        }
    };
    getByAllData = () => {
        return this.service.find({});
    };
    getByPosId = (id: number) => {
        return this.service.getOne(id);
    };
    deleteRecord = (id: number) => {
        return this.service.delete(id);
    };
    getDetayliArama = (aramaModel: HbsVeznePoscihaztanimDTO) => {
        let req: ApiRequest<HbsVeznePoscihaztanimDTO> = {
            sorts: [
                { fieldName: "id", ascending: false },
            ],
            filters: {
                groupOperator: 'and',
                predicates: []
            }
        }
        if (aramaModel.multiOrganizasyon?.length > 0) {
            let orgArr = aramaModel.multiOrganizasyon.split(",");
            req.filters.predicates.push({
                fieldName: "fkOrganizasyon",
                operator: "in",
                not: false,
                value1: orgArr
            })
        }
        if (aramaModel.adi)
            req.filters.predicates.push({
                fieldName: "adi",
                operator: "like",
                value1: helper.upperCase(aramaModel.adi)
            })
        if (aramaModel.ipadres)
            req.filters.predicates.push({
                fieldName: "ipadres",
                operator: "like",
                value1: aramaModel.ipadres
            })
        if (aramaModel.fkPoscihaztip)
            req.filters.predicates.push({
                fieldName: "fkPoscihaztip",
                operator: "=",
                value1: aramaModel.fkPoscihaztip
            })
        return this.service.find(req)
    };
}

export default new HbsVeznePoscihaztanimDTOService();